export default "__VITE_ASSET__CX9bX$0p__"